import MatchedMap from 'utilities/src/matchedMap';

import { ButtonBGEnum } from '../../../../types/_bg';

import buttonSiteGreenLightTheme from './_light';
import buttonSiteGreenDarkTheme from './_dark';

export default new MatchedMap([
  [ButtonBGEnum.Light, buttonSiteGreenLightTheme],
  [ButtonBGEnum.Dark, buttonSiteGreenDarkTheme],
]);
